import groq from 'groq';

import { ASSET, RICH_TEXT } from '../common';
import { PROMO_CODE_BLOCK_OR_PARENT } from '../product';
import { AMAZON_BUTTON } from '../product/amazonButton';
import { PRODUCT_OVERRIDES } from '../product/productBlock';
import { PRODUCT_MEDIA_FULL_LIST } from '../product/productMedia';
import { PRODUCT_SLUG } from '../product/productSlug';
import { SEE_IT_IN_ACTION } from '../product/seeItInAction';

export const PRODUCT_WITH_VARIANTS = `
  product -> {
    ${PRODUCT_SLUG},
    "mostPopularVariantId": mostPopular->store.gid,
    "bestValueVariantId": bestValue->store.gid,
    "media": ${PRODUCT_MEDIA_FULL_LIST},
    "bulletPoints": bulletPointsV2[] { ${RICH_TEXT} },
    frontrowMD {
      "productId": coalesce(^.frontrowMDProductId, null),
      "isFrontrowBadgeEnabled": coalesce(isFrontrowBadgeEnabled, false),
    },
    ${SEE_IT_IN_ACTION},
    disclaimer
  },
  variants[] -> { "gid": store.gid }
`;

export const SUPPLEMENT_PICKER = groq`
  _type,
  products[] {
    ${PRODUCT_WITH_VARIANTS},
    ${PRODUCT_OVERRIDES},
    selector {
      ${ASSET},
      label
    }
  },
  "purchaseType": select(purchaseType == "all" => undefined, purchaseType),
  "promoCodes": ${PROMO_CODE_BLOCK_OR_PARENT},
  ctaType,
  ${AMAZON_BUTTON}
`;

export const SUPPLEMENT_PICKER_BLOCK = groq`
  _type == 'timeline_supplementPicker' => {
    ${SUPPLEMENT_PICKER}
  }
`;
